import React, { createContext, useContext, useEffect, useState } from 'react';
import { db, auth } from './Firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [leases, setLeases] = useState([])
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      // console.log("AUTH STATE CHANGING");
      if (user) {
        try {
          const docRef = doc(db, 'lessee', user.uid);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            const userData = docSnap.data();
            if (userData.adminAuthorization) {
              const temp = [];
              setUser(() => ({ uid: user.uid, ...userData }));
              const leasePromises = userData.leaseList.map(element => getDoc(doc(db, 'lease', element)));
              Promise.all(leasePromises)
                .then(leaseSnapshots => {
                  const temp = leaseSnapshots.filter(snapshot => snapshot.exists()).map(snapshot => snapshot.data());
                  setLeases(temp);
                })
                .catch(error => console.error('Error fetching lease data:', error));
            }
          } else {
            const docRef = await getDoc(doc(db, "admin", user.uid));
            if (docRef.exists()) {
              const docRefData = docRef.data();
              // console.log(docRefData)
              setUser({ admin: true, uid: user.uid, ...docRefData });
              // console.log('User data not found in Firestore');
            }
          }
        } catch (error) {
          console.error('Error fetching user data from Firestore:', error);
        }
      } else {
        // No user is signed in
        setUser(null);
      }
      setLoading(false)
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    console.log("User Data is: ", user)
  }, [user])

  return (
    <UserContext.Provider value={{ user, setUser, loading, setLoading, leases, setLeases }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
